export default "__VITE_ASSET__By1xf3T___"